import Masonry from 'masonry-layout/dist/masonry.pkgd.min'
import imagesLoaded from 'imagesloaded'

export const renderMasonryLayoutMagazine = (container) => {

  const msnry = new Masonry(container, {
    itemSelector: '.magazine-related-articles__item',
    static: true,
    gutter: 120,
    useMin: true,
    horizontalOrder: true,
  })

  imagesLoaded(container).on('progress', () => {
    msnry.layout()
  })
}
